import * as types from '../types.js';

export default {

	html: `
		<style>
			#invoice #company_id		{ width: 10rem;		}
			#invoice #id				{ width: 5rem; text-align: right;	}
			#invoice #io_id				{ width: 5rem; text-align: right;	}
			#invoice #io_type			{ width: 8rem; 		}
			#invoice #cfop				{ width: 30rem;		}
			#invoice #insurance			{ width: 5rem; text-align: right;	}
			#invoice #expenses			{ width: 5rem; text-align: right;	}
			#invoice .info		 		{ width: 70%;		}
			#invoice .note		 		{ width: 29%;		}
			#invoice .type 				{ width: 10rem;		}
			#invoice .number 			{ width: 10rem; text-align: center;	}
			#invoice .code 				{ width: 4rem; text-align: center;	}
			#invoice .message 			{ width: 20rem;		}
			#invoice .datetime 			{ width: 10rem; text-align: center;	}
			#invoice #ref_key			{ width: 30rem;		}
		</style>
		<form id="invoice" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa<sup>*</sup>
					<input id="company_id" type="text" list="companies" required>
				</label>
				<label title="Número da nota fiscal">Nota
					<input id="id" type="text" disabled>
				</label>
				<label title="Número da entrada/saída vinculada">E/S<sup>*</sup>
					<input id="io_id" type="text" required>
				</label>
				<label title="Tipo do movimento vinculado">Tipo<sup>*</sup>
					<input id="io_type" type="text" list="io_types" value="O" disabled>
				</label>
				<label title="Código Fiscal de Operações e Prestações">CFOP<sup>*</sup>
					<input id="cfop" type="text" list="cfops" required>
				</label>
				<label title="Valor do seguro">Seguro
					<input id="insurance" type="text">
				</label>
				<label title="Outras despesas acessórias">Despesas
					<input id="expenses" type="text">
				</label>
			</div>
			<div class="fsb">
				<label class="info" title="Informações complementares de interesse do contribuinte">Informações Complementares
					<textarea id="info" rows="8"></textarea>
				</label>
				<label class="note" title="Correção ou justificativa de cancelamento">Anotação
					<textarea id="note" rows="8"></textarea>
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Tipo</th>
							<th>Protocolo</th>
							<th>Código</th>
							<th>Mensagem</th>
							<th>Data/Hora</th>
							<th>Contingência</th>
						</tr>
					</thead>
					<tbody>
						<tr class="row">
							<td>
								<input id="checkbox-0" type="checkbox" disabled>
							</td>
							<td title="Tipo de protocolo">
								<select id="type-0" class="type" disabled>
									<option value="1">Autorização</option>
									<option value="2">Correção</option>
									<option value="3">Cancelamento</option>
									<option value="4">Inutilização</option>
								</select>
							</td>
							<td title="Número do protocolo">
								<input id="number-0" class="number" type="text" disabled>
							</td>
							<td title="Código de retorno">
								<input id="result_code-0" class="code" type="text" disabled>
							</td>
							<td title="Mensagem de retorno">
								<input id="result_text-0" class="message" type="text" disabled>
							</td>
							<td title="Data/hora do retorno">
								<input id="result_datetime-0" class="datetime" type="text" disabled>
							</td>
							<td title="Uso de ambiente de contingência">
								<input id="contingency-0" class="contingency" type="checkbox" disabled>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<label title="Chave da nota fiscal referenciada em devoluções">Nota Referenciada
						<input id="ref_key" type="text">
					</label>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#invoice',
		afterEditSetValues(fs)
		{
			setTimeout(() =>
			{
				const io = fs.form.getFieldBySelector('#io_type');
				if (io && typeof io.publish === 'function')
					io.publish('change', io, io.getValue());
			}, 50);
		},
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#io_id' }, types: [types.pubsub(), types.number(0, 2)] },
		{ properties: { selector: '#io_type' }, types: [types.pubsub(), types.opt_io_type(), types.datalist()] },
		{ properties: { selector: '#cfop' }, types: [types.pubsub(), types.datalist(), types.obs_cfops_invoice()] },
		{ properties: { selector: '#ref_key' }, types: [types.nfe_key()] },
		{ properties: { selector: '#insurance' }, types: [types.number(2)] },
		{ properties: { selector: '#expenses' }, types: [types.number(2)] },
		{ properties: { selector: '#info' }, types: [types.textarea()] },
		{ properties: { selector: '#note' }, types: [types.textarea()] },
		{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#type-0' }, types: [] },
		{ properties: { selector: '#number-0' }, types: [] },
		{ properties: { selector: '#result_code-0' }, types: [] },
		{ properties: { selector: '#result_text-0' }, types: [] },
		{ properties: { selector: '#result_datetime-0' }, types: [] },
		{ properties: { selector: '#contingency-0' }, types: [] },
	]

};

